import styled from 'styled-components'

export const RosterViewLinksWrapper = styled.div`
  position: absolute;
  right: 40px;
  top: 33px;

  .button-delete {
    display: block;
    position: relative;
    float: left;
  }

  & > * {
    margin: 0 20px 0 0;
  }

  & > *:last-child {
    margin-left: 16px;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Campaigns/RosterView/RosterViewLinksWrapper/index.js